<template>
  <v-layout row justify-center>
    <v-dialog :value="dialog" @input="$emit('onCancel')" width="500px" flat>
      <v-card flat>
        <v-card-title>
          <h3>{{ $t("screener.refund.title") }}</h3>
        </v-card-title>
        <!-- <v-card-text class="grey lighten-3"> -->
        <v-divider></v-divider>
        <v-layout row wrap class="pa-3">
          <v-flex xs12 class="pb-3">
            <span class="grey--text text--darken-1">
              <b>{{ $t("screener.refund.screening") }}</b>
            </span>
            <div class="headline">{{ plan }}</div>
          </v-flex>
          <v-flex xs12 class="pb-3">
            <span class="grey--text text--darken-1">
              <b>{{ $t("screener.refund.total_to_refund") }}</b>
            </span>
            <div class="headline">
              {{ getCurrencySymbol(currency) }}&nbsp;{{ max_refundable_amount }}
            </div>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Refundable Amount"
              :rules="[
                rules.required,
                rules.floating_number,
                rules.inBetween(
                  0.1,
                  max_refundable_amount,
                  localRefundableAmount
                )
              ]"
              v-model.number="localRefundableAmount"
              :prefix="getCurrencySymbol(currency)"
              color="primary"
              :readonly="!isAmountEditable"
            >
            </v-text-field>
            <v-select
              v-model="localReason"
              :items="reasons"
              hide-details
              label="Reason"
              single-line
              item-value="value"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>

        <div class="pa-3">
          <h3 class="red--text pb-2">
            {{ $t("screener.monetization.refund.warning.title") }}
          </h3>
          <div
            class="greyDarken2--text pb-1"
            v-html="$t('screener.monetization.refund.warning.content')"
          ></div>
          <slot name="note"></slot>
        </div>
        <!-- </v-card-text> -->
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn dark @click.stop="$emit('onCancel')" color="grey">{{
            $t("rms.button.cancel")
          }}</v-btn>
          <v-btn dark @click.stop="$emit('onRefund')" color="primary">{{
            $t("screener.btn.refund")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { currencySymbol } from "@/mixins/monetization";
import rules from "@/validation";

export default {
  data() {
    return {
      rules,
      max_refundable_amount: null,
      reasons: [
        { text: "Duplicate", value: "duplicate" },
        { text: "Fraudulent", value: "fraudulent" },
        { text: "Requested By Customer", value: "requested_by_customer" },
        { text: "Other", value: "" }
      ]
    };
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    plan: { type: String, default: null },
    refundable_amount: { default: null },
    currency: { type: String, default: null },
    is_full_refund: { type: Boolean, default: false },
    reason: { type: String, default: null },
    isAmountEditable: { type: Boolean, default: true }
  },
  watch: {
    dialog(value) {
      this.max_refundable_amount = value ? this.refundable_amount : null;
    }
  },
  mixins: [currencySymbol],
  computed: {
    localRefundableAmount: {
      get: function() {
        return this.refundable_amount;
      },
      set: function(value) {
        this.$emit("update:refundable_amount", value);
      }
    },
    localReason: {
      get: function() {
        return this.reason;
      },
      set: function(value) {
        this.$emit("update:reason", value);
      }
    }
  }
};
</script>

<style>
</style>
